import { withTimeSystem } from "../../constants/orbitMetadata";
import { getElementDescendant } from "../../helpers/utils";
import { getDisplayValue } from "../conjunctions/conjunctionUiUtils";
import { formatDate } from "../events/eventEvolutionUtils";
import { ObjectIdentityTitle } from "../ObjectIdentityTitle";
import { getObjectValue } from "./FleetStatusCardList";

export const CompactObject = ({
  conjunction,
  orbitElement,
}: {
  conjunction: unknown;
  orbitElement: "target" | "chaser";
}) => {
  const sourceValue = getDisplayValue(
    getObjectValue(conjunction, orbitElement, ["sourceOfInformation"]),
  );

  const roleLabel = orbitElement === "target" ? "primary" : "secondary";
  const updateTimeValue = getDisplayValue(
    getElementDescendant(conjunction, [`${orbitElement}OrbitUpdateTime`]),
  );

  return (
    <div className="min-w-0 max-w-[280px] rounded-lg border border-slate-200 bg-slate-50/80 px-2 py-1.5">
      <div className="mb-1 text-[11px] font-semibold uppercase text-slate-500">
        {roleLabel}
      </div>
      <ObjectIdentityTitle
        cospar={getDisplayValue(
          getObjectValue(conjunction, orbitElement, [
            "spaceObject",
            "cosparId",
          ]),
        )}
        objectId={getDisplayValue(
          getObjectValue(conjunction, orbitElement, ["spaceObject", "id"]),
        )}
        linkToObject
        meta={`${sourceValue} | ${withTimeSystem("Update Time")}: ${formatDate(updateTimeValue)}`}
        name={getDisplayValue(
          getObjectValue(conjunction, orbitElement, ["spaceObject", "name"]),
        )}
        norad={getDisplayValue(
          getObjectValue(conjunction, orbitElement, ["spaceObject", "noradId"]),
        )}
        variant="compact"
      />
    </div>
  );
};
